export default "__VITE_ASSET__30e2af96__"